module.exports = __webpack_public_path__ + "summernote.75e7f4fb887aa2623e2e.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/summernote/font/summernote.ttf?dc97c88102d55aed645e5f227c58ba5b
// module id = ../../../../../src/assets/summernote/font/summernote.ttf?dc97c88102d55aed645e5f227c58ba5b
// module chunks = styles